import React, { useState } from "react";
import { Download } from "lucide-react";
import { formatSize } from "./constants";
import { extOf, kindOf } from "./fileKinds";
import { tint } from "./format";
import AuthImage from "./AuthImage";
import AttachmentLightbox from "./AttachmentLightbox";

/** Files sent inside a conversation message: image thumbnails + file cards, click to preview. */
const MessageFiles = ({ files, align = "flex-start" }) => {
  const [openIndex, setOpenIndex] = useState(null);
  if (!files?.length) return null;
  const images = files.map((f, i) => ({ f, i })).filter(({ f }) => f.isImage);
  const others = files.map((f, i) => ({ f, i })).filter(({ f }) => !f.isImage);

  return (
    <div className="er-mfiles" style={{ alignItems: align }}>
      {images.length > 0 && (
        <div className="er-mimgs" data-n={Math.min(images.length, 3)} style={{ justifyContent: align }}>
          {images.map(({ f, i }) => (
            <button key={f.id} type="button" className="er-btn er-mimg" title={f.name} onClick={() => setOpenIndex(i)}>
              <AuthImage url={f.url} alt={f.name} />
            </button>
          ))}
        </div>
      )}
      {others.map(({ f, i }) => {
        const kind = kindOf(f.name);
        const Icon = kind.icon;
        return (
          <button key={f.id} type="button" className="er-btn er-mfile" title={f.name} onClick={() => setOpenIndex(i)}>
            <span className="er-mficon" style={{ background: tint(kind.color, 16), color: kind.color }}><Icon size={18} strokeWidth={1.8} /></span>
            <span style={{ minWidth: 0, flex: 1, textAlign: "start" }}>
              <span className="er-ellipsis" style={{ display: "block", fontSize: 12.5, fontWeight: 600 }}>{f.name}</span>
              <span style={{ fontSize: 11, color: "var(--faint)" }}>{extOf(f.name).toUpperCase() || kind.kind} · {formatSize(f.size)}</span>
            </span>
            <Download size={14} color="var(--faint)" />
          </button>
        );
      })}
      {openIndex !== null && (
        <AttachmentLightbox files={files} index={openIndex} onIndex={setOpenIndex} onClose={() => setOpenIndex(null)} />
      )}
    </div>
  );
};

export default MessageFiles;
